import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-system-notification'

export const getAll = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const markAsRead = async (token, notificationId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/mark-as-read`, 
        { notificationId }, 
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}
